<script>
    import Button from "./Button.svelte";

    import { selectedPaymentCsvFile } from "../../stores";

    import { goToURL } from "../../Utils/utilFunctions.svelte";
    import NotificationModal from "./NotificationModal.svelte";

    let fileInput;

    export let isPostCSVModalOpen = false;
    export let closeModal = () => {};

    $: isSubmitButtonDisabled = !$selectedPaymentCsvFile.content;

    $: if (isPostCSVModalOpen) setTimeout(() => enableFileDragAndDrop(), 0);
    else disableFileDragAndDrop();

    const enableFileDragAndDrop = () => {
        const enableDropArea = document.getElementById("enableDropArea");
        const uploadFileModal = document.getElementById("uploadFileModal");

        uploadFileModal.addEventListener("dragover", function (e) {
            e.preventDefault();

            enableDropArea.classList.add("outline-dashed");
            enableDropArea.classList.add("outline-secondary");
            enableDropArea.classList.add("outline-2");
        });

        uploadFileModal.addEventListener("dragleave", function (e) {
            enableDropArea.classList.remove("outline-dashed");
            enableDropArea.classList.remove("outline-secondary");
            enableDropArea.classList.remove("outline-2");
        });

        uploadFileModal.addEventListener("drop", function (e) {
            e.preventDefault();

            enableDropArea.classList.remove("outline-dashed");
            enableDropArea.classList.remove("outline-secondary");
            enableDropArea.classList.remove("outline-2");
        });

        enableDropArea.addEventListener("drop", function (e) {
            e.preventDefault();

            onFileChange(e, true);

            this.classList.remove("outline-dashed");
            this.classList.remove("outline-secondary");
            this.classList.remove("outline-2");
        });
    };

    const disableFileDragAndDrop = () => {
        const enableDropArea = document.getElementById("enableDropArea");

        enableDropArea &&
            enableDropArea.removeEventListener("drop", onFileChange);
    };

    const onFileChange = (e, isDropFile = false) => {
        const inputField = document.getElementById("fileNamePlaceholder");

        inputField.innerText = isDropFile
            ? e.dataTransfer.files[0].name
            : e.target.files[0].name;

        const file = isDropFile ? e.dataTransfer.files[0] : e.target.files[0];
        const fileType = file?.type;
        const fileName = _getFileName(file, fileType);

        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (e) => {
            $selectedPaymentCsvFile = {
                name: fileName,
                type: fileType,
                content: e.target.result.split(",")[1],
            };
        };
    };

    const cancelPostFile = () => {
        closeModal();

        $selectedPaymentCsvFile = {};

        const inputField = document.getElementById("fileNamePlaceholder");
        inputField.innerText = "";

        const fileInput = document.getElementById("fileInput");
        fileInput.value = "";
    };

    const goToResultPage = () => {
        closeModal();

        const inputField = document.getElementById("fileNamePlaceholder");
        inputField.innerText = "";

        const fileInput = document.getElementById("fileInput");
        fileInput.value = "";

        goToURL(`/Payments/eftcsv`);
    };

    // HELPER FUNCTIONS
    const _getFileName = ({ name }, type) => {
        return name;
    };
</script>

<NotificationModal
    title="Upload CSV File"
    isModalOpen={isPostCSVModalOpen}
    showCancelBtn={false}
    showConfirmBtn={false}
    closeModalFunction={cancelPostFile}
    customizeId="uploadFileModal"
    btnOptions={[
        {
            text: "Cancel",
            class: "btn btn-accent",
            function: () => cancelPostFile(),
        },
        {
            text: "Submit",
            loading: isSubmitButtonDisabled,
            function: () => goToResultPage(),
        },
    ]}
>
    <div class="flex flex-1 text-[#000]" id="enableDropArea">
        <p
            id="fileNamePlaceholder"
            class="w-1/2 pt-2 pl-2 border-2 rounded-tl-lg rounded-bl-lg text-secondary"
        />
        <button
            class="w-1/2 p-2 rounded-tr-lg rounded-br-lg bg-[#E8E8E8] text-secondary"
            on:click|preventDefault={() => fileInput.click()}
        >
            Select or drag and drop here
        </button>
        <input
            type="file"
            accept=".csv"
            style="display: none"
            id="fileInput"
            on:change={onFileChange}
            bind:this={fileInput}
        />
    </div>
</NotificationModal>
